export default function Support() {
  const supports = [
    {
      title: '學習與發展獎助金',
      description: '用於課程、技能培訓、證照、實習或職涯發展',
      color: 'bg-[#FFE5E5]',
      image: 'https://public.readdy.ai/ai/img_res/2ac2bdd8d5c7337b312c64442d27c731.jpg'
    },
    {
      title: '導師陪伴',
      description: '由企業、教育界或公益界導師提供指導與支持',
      color: 'bg-[#D4F4DD]',
      image: 'https://readdy.ai/api/search-image?query=mentor-and-young-student-having-conversation-in-bright-office-simple-clean-background-mint-green-tones-warm-natural-lighting-professional-guidance-vertical-composition-shallow-focus&width=600&height=800&seq=support002&orientation=portrait'
    },
    {
      title: '資源連結',
      description: '包含實習機會、職涯諮詢、培訓課程與社群連結',
      color: 'bg-[#E8E8E8]',
      image: 'https://readdy.ai/api/search-image?query=networking-event-young-professionals-connecting-simple-clean-background-neutral-gray-tones-bright-modern-space-business-cards-and-handshake-vertical-format-professional-photography&width=600&height=800&seq=support003&orientation=portrait'
    },
    {
      title: '社會參與機會',
      description: '邀請獲獎者參與公益活動,培養公共責任與影響力',
      color: 'bg-[#FFF4E0]',
      image: 'https://readdy.ai/api/search-image?query=volunteers-working-together-in-community-service-warm-yellow-beige-background-simple-clean-setting-teamwork-helping-hands-vertical-composition-natural-lighting-inspiring-atmosphere&width=600&height=800&seq=support004&orientation=portrait'
    }
  ];

  return (
    <section id="support" className="py-24 bg-[#F5F1E8]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <p className="text-sm text-gray-500 mb-6 tracking-wider">SUPPORT & RESOURCES</p>
          <h2 className="text-6xl font-bold text-gray-900 leading-tight mb-4">
            獎助內容
          </h2>
          <p className="text-xl text-gray-600 italic font-light">Support & Resources</p>
        </div>

        <div className="grid grid-cols-4 gap-6">
          {supports.map((support, index) => (
            <div key={index} className="rounded-3xl overflow-hidden group cursor-pointer">
              <div className={`${support.color} h-80 relative overflow-hidden`}>
                <img
                  src={support.image}
                  alt={support.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="bg-white p-6 text-center">
                <h3 className="text-lg font-bold text-gray-900 mb-2">{support.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{support.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-base text-gray-600">
            每屆少華獎預計遴選 <strong className="text-[#F4A261]">5–10 位</strong> 優秀青年,提供全方位支持
          </p>
        </div>
      </div>
    </section>
  );
}
